// ページの非表示有効化
function hideContents() {
  body.style.display = 'none';
}

// ページの非表示無効化
function showContents() {
  body.style.display = '';
}

const body = document.querySelector('body');
const bodyDisplay = body.style.display;
hideContents()

const subDirectory = window.location.href.split(window.location.origin)[1];
switch (subDirectory) {
  case '/collections/':
  case '/products/':
  case '/products':
    window.location.href = window.location.origin + '/collections';
    break;
  case '/collections/recommend/':
    window.location.href = window.location.origin + '/collections/recommend';
    break;
  case '/blogs/news/switch-tieup/':
    window.location.href = window.location.origin + '/blogs/news/switch-tieup';
    break;
  case '/collections/recommend-evolution-9-collection/':
    window.location.href = window.location.origin + '/collections/recommend-evolution-9-collection';
    break;
  case '/collections/recommend-heritage-collection/':
    window.location.href = window.location.origin + '/collections/recommend-heritage-collection';
    break;
  case '/collections/recommend-sport-collection/':
    window.location.href = window.location.origin + '/collections/recommend-sport-collection';
    break;
  case '/products/SLGH020':
    window.location.href = window.location.origin + '/products/slgh021';
    break;
  default: showContents();   // ページにリダイレクトが必要ではない場合はページを表示する
}